import * as Scrivito from "scrivito";
import { formatDate } from "utils";
import React from "react";
import cx from "classnames";
import { Icon } from "components";
import { useTranslate } from "hooks";
import { useNavigateToProject } from "hooks/projectHooks";
import styles from "./ProjectInfo.module.scss";

export const ProjectInfo = Scrivito.connect(
  ({ id, title, updatedAt, editedBy, projectId }) => {
    const translate = useTranslate();
    const navigateToProject = useNavigateToProject();

    return (
      <div
        className={cx(
          "px-2_5 py-2 d-flex flex-nowrap justify-content-between border-bottom cursor-pointer",
          styles.hoverEffect,
        )}
        onClick={() => navigateToProject.item(projectId)}
        data-testid="ProjectInfo_project-link"
      >
        <div className="d-flex flex-column">
          <h6 className="d-flex align-items-center text-gray-700 mb-0 fs-md">
            <span className={styles.textWrapEllipsis}>{title}</span>
            <Scrivito.LinkTag
              data-testid="ProjectInfo_project-link"
              onClick={() => navigateToProject.item(projectId)}
              className={styles.linkIcon}
              aria-label={`link to ${title}`}
            >
              <Icon
                iconName="arrow-up-right-square-regular"
                prefix="trox"
                data-testid="arrow-up-right-square-regular-icon"
                className={cx("icon-16 ms-2 text-gray-400", styles.linkIcon)}
              />
            </Scrivito.LinkTag>
          </h6>
          <span className="text-gray-400">{id}</span>
        </div>
        <div className="d-flex flex-column">
          <span className="text-gray-700 fs-md">
            {formatDate(updatedAt, "DD.MM.YYYY", "YYYY-MM-DD")}
          </span>
          <span className="text-gray-400">
            {translate("PROJECT_EDITED_BY", editedBy)}
          </span>
        </div>
      </div>
    );
  },
);
